import { MembersCta } from './components/MembersCta';
import { TakingAction } from './components/TakingAction';
import { TrendingPetitionsImpact } from './components/TrendingPetitionsImpact';
import { VictoriesImpact } from './components/VictoriesImpact';

export const PageBody = () => {
	return (
		<div>
			<TakingAction />
			<VictoriesImpact />
			<MembersCta />
			<TrendingPetitionsImpact />
		</div>
	);
};
